// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"App_spinnerContainer__aHs9o"};